import { createUseStyles } from '@glu/theming';

/* istanbul ignore file */
const styles = ({
  palette: {
    colors: { tundora: black },
    common: { white },
    error,
    text
  },
  spacing: { unit },
  typography: { fontWeightHeavy, headline2, title }
}) => ({
  additionalValidation: {
    marginTop: '-30px !important',
    paddingBottom: 10
  },
  tableContent: {
    display: 'flex',
    justifyContent: 'center'
  },
  wrapper: {},
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: unit * 3
  },
  title: {
    fontSize: headline2.fontSize,
    fontFamily: title.fontFamily,
    fontWeight: fontWeightHeavy,
    margin: 0
  },
  subtitle: {
    marginTop: unit * 3.75
  },
  mapName: {
    marginTop: unit * 3,
    width: 300
  },
  delimiters: {
    width: 300,

    '& > label': {
      width: '100%'
    }
  },

  alertTitle: {
    fontSize: 16,
    margin: [7, 0, 10, 0],
    textTransform: 'uppercase',
    fontWeight: 'bold'
  },

  alert: {
    '&[data-component-name="glu-alerts--base-alert"][class*="alert"]': {
      width: 450,
      margin: `0 auto ${4 * unit}px`
    }
  },

  optionsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& > *': {
      width: 300
    }
  },

  hasError: {
    '&$fieldPosition, &$replacementValue': {
      '& input': {
        border: `1px solid ${error.dark}`,
        color: error.dark
      },
      '& span': {
        display: 'block',
        color: error.dark,
        marginTop: 5
      }
    }
  },

  hidden: {
    display: 'none'
  },

  fieldPosition: {
    maxWidth: 20.5 * unit,
    '& > span': {
      display: 'none'
    }
  },

  extraOptions: {
    fontSize: 14
  },

  endOfRecord: {
    marginTop: 10
  },

  countInput: {
    width: 140,
    marginBottom: 15,
    marginTop: 15,

    '& input': {
      with: 60,
      display: 'inline-block'
    },
    '& label': {
      display: 'inline-block',
      color: '#6e6e6e',
      textTransform: 'uppercase',
      marginBottom: 0,
      marginRight: 10
    }
  },

  table: {
    marginTop: 30,
    marginBottom: 30,
    fontSize: 14,
    '& td, & th': {
      padding: 10
    },

    '& td': {
      padding: 10
    },

    '& tbody tr:last-child': {
      borderBottom: '1px solid #ccc'
    },

    '& tbody tr': {
      borderTop: '1px solid #ccc'
    },
    '& [class*="checkboxIcon-"][class*="selected-"]': {
      backgroundColor: black,
      '& svg': {
        stroke: white
      }
    }
  },
  tableHeading: {
    borderBottom: '3px solid #ccc',
    '& th': {
      fontSize: 12,
      fontWeight: 'normal',
      textTransform: 'uppercase'
    }
  },
  columnGroupHeading: {
    '& th': {
      paddingTop: 0,
      paddingBottom: 0,
      fontSize: `${unit * 1.5}px`,
      fontWeight: fontWeightHeavy,
      textTransform: 'uppercase'
    }
  },

  headingActions: {
    background: '#f2f2f2',
    borderBottom: '1px solid #ccc',
    '& th': {
      fontSize: 14
    }
  },

  tableSection: {
    '& > td': {
      fontSize: 12,
      background: '#f2f2f2',
      borderTop: '1px solid #ccc',
      fontWeight: 'bold'
    }
  },

  tableInput: {
    '& label': {
      margin: [1 * unit, 0, 0, 0],
      minHeight: 8.75 * unit
    },
    '& .form-group': {
      margin: 0,
      maxWidth: 100
    },

    '& .help-block': {
      fontSize: 14
    }
  },

  charges: {
    paddingTop: 1 * unit,
    minHeight: 8.75 * unit
  },

  tableHeadingDesc: {
    fontSize: 12,
    color: text.dark,
    fontWeight: 'normal'
  },

  replacementValue: {
    width: 300,

    '& div.form-group': {
      maxWidth: 300
    }
  },

  tableFieldOptional: {
    position: 'relative',
    '&:before': {
      content: '"Optional"',
      width: 10,
      height: 10,
      position: 'relative',
      left: 0,
      display: 'block',
      color: '#6e6e6e',
      top: '-3px',
      fontSize: 10
    }
  },

  tableDropdown: {
    margin: 0,
    width: '100%',

    '& [data-qa*=-selection]': {
      textOverflow: 'initial',
      maxWidth: '100%'
    },

    '& > label': {
      width: '100%'
    }
  },
  dropdownTopPadding: {
    paddingTop: 3 * unit
  },
  hideDropdownLabel: {
    '& label': {
      height: 0,
      width: 0,
      overflow: 'hidden',
      position: 'absolute'
    }
  },
  tableCheckbox: {
    display: 'flex',
    marginTop: 5,
    marginRight: 10,
    '& [class*="checkboxIcon-"][class*="selected-"]': {
      backgroundColor: black,
      '& svg': {
        stroke: white
      }
    }
  },

  footer: {
    marginBottom: 30,
    textAlign: 'center',

    '& button': {
      margin: 10,
      textTransform: 'capitalize'
    }
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    margin: 100
  },
  ibanAccountType: {
    whiteSpace: 'pre-line'
  },
  ibanAccountTypeIcon: {
    position: 'relative',
    top: 0.5 * unit,
    paddingLeft: 0.5 * unit
  },
  countryCodeDownloadBtn: {
    paddingLeft: 2 * unit,
    '& .icon-container-arrow-down-next': {
      marginRight: 0.5 * unit
    }
  }
});

export default createUseStyles(styles);
